import React from "react";
import styles from "./RadioGroup.module.css";

function RadioGroup({
  options,
  handleSelect,
  selected,
  groupName,
  label,
  required,
  width,
  anonStyle
}) {
  return (
    <fieldset
      className={anonStyle ? styles.anonContainer : styles.container}
      name={groupName}
      style={{ width: width }}
    >
      <div className={`${
        anonStyle ? styles.anonLabel : styles.legend
        } ${required && (anonStyle ? `${styles.anonRequired}` : "required-field")}`}
        id={`${groupName}label`}
        >
        {label}
      </div>
      <div className={styles.toggleContainer} role="radiogroup" aria-labelledby={`${groupName}label`}>
      {options.map((option, index) => {
        return (
          <label
            htmlFor={`${groupName}${option.value}`}
            className={anonStyle ? `${styles.anonToggleContainer} ${option.value === selected?.value && styles.selected}`
              :`${styles.radioLabel} ${option.value === selected?.value && styles.selected}`
            }
            key={index}
          >
            {option.text}
            <input
              id={`${groupName}${option.value}`}
              key={index}
              type="radio"
              className={`noselect ${
                anonStyle ? styles.anonToggleBase : styles.toggleBase
              }`}
              onFocus={() => handleSelect(option)}
              name={groupName}
            />
          </label>
        );
      })}
      </div>
    </fieldset>
  );
}

export default RadioGroup;
